import React from "react";

export default () =>
    <div className="content shadow">
        <h3>Prosjekter</h3>
        <p>Under utvikling - kommer senere.</p>
    </div>;